import { Container, Row, Col } from "react-bootstrap";
import { db } from "../../firebase";
import { useState } from "react";
import { ref, set } from "firebase/database";
import Button from "react-bootstrap/Button";
import Form from 'react-bootstrap/Form';

function Connect() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");
    const [errors, setErrors] = useState([]);

    function validateEmail(email) {
        // Regular expression for validating an email address
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return emailPattern.test(email);
    }

    function validateForm(name, email, phone, message) {
        setErrors(errors.splice(0, errors.length));
        if (name === '' || email === '' || phone === '' || message === '') {
            setErrors([...errors, 'All fields are required']);
            return false;
        }
        if (!validateEmail(email)) {
            setErrors([...errors, 'Email is not valid']);
            return false;
        }
        return true;
    }

    function writeUserData(name, email, phone, message) {
        const inputId = crypto.randomUUID();
        const isValid = validateForm(name, email, phone, message);
        if (isValid) {
            set(ref(db, 'request/' + inputId), {
                username: name,
                email: email,
                phone: phone,
                message: message
            });
            setName('');
            setEmail('');
            setPhone('');
            setMessage('');
            setErrors(errors.splice(0, errors.length));
        }
    }
    return (
        <Container fluid className="project-section" style={{paddingRight: '36px', paddingLeft:'36px', minHeight: '90vh' }} >
            <Row>
                <Col
                    md={7}
                    style={{ paddingTop: "75px" }}
                    className="about-img"
                >
                    <div style={{ color: 'red' }}>
                        {errors.map((message, index) => (
                            <div>
                                <span key={index}>{message}</span> <br />
                            </div>
                        ))}
                    </div>
                    <h2>Request For Visit</h2>
                    <br/>
                    <Form.Control
                        value={name} onChange={(e) => setName(e.target.value)} name="name" type="text" id="name" size="30" placeholder="Name"
                    />
                    <br />
                    <Form.Control value={email} onChange={(e) => setEmail(e.target.value)} name="email" type="text" id="email" size="30" placeholder="Email" />
                    <br />
                    <Form.Control value={phone} onChange={(e) => setPhone(e.target.value)} name="phone" type="text" id="phone" size="30" placeholder="Phone" />
                    <br />
                    <Form.Control value={message} onChange={(e) => setMessage(e.target.value)} name="comments" cols="40" rows="5" id="comments" placeholder="Message"></Form.Control>
                    <br />
                    <Button className="btn btn-default btn-submit submit" id="submit" onClick={() => writeUserData(name, email, phone, message)}>Submit</Button>
                </Col>
                <Col md={5}>
                    <Row>
                        <Col md={12} style={{ textAlign: "left", marginTop: "75px" }}>
                            <span className="purple" >
                                Address
                            </span>
                        </Col>
                    </Row>
                    <Row style={{ textAlign: "left", marginTop: "4px" }}>
                        <Col md={12} >
                            <address>
                                Madhuvan club life, <br />
                                Behind motnath mahadev temple<br />
                                Harni road- Vadodara<br />
                            </address>
                        </Col>  
                    </Row>
                    <Row>
                        <Col md={4} sm={6}>
                            <Row>
                                <Col md={12} style={{ textAlign: "left", marginTop: "20px" }}>
                                    <span className="purple" >
                                        Contact Number
                                    </span>
                                </Col>
                            </Row>
                            <Row style={{ textAlign: "left", marginTop: "4px" }}>
                                <small>
                                    +91 97375 55900<br />
                                    +91 63513 95060
                                </small>
                            </Row>
                        </Col>
                        <Col md={4} sm={6}>
                            <Row>
                                <Col md={12} style={{ textAlign: "left", marginTop: "20px" }}>
                                    <span className="purple" >
                                        Emial
                                    </span>
                                </Col>
                            </Row>
                            <Row style={{ textAlign: "left", marginTop: "4px" }}>
                                <address>
                                    <small>
                                        21interiorstudio@gmail.com
                                    </small>
                                </address>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
};
export default Connect;